/* globals $ */

var showOrHideAddress = function(value, streamingFields, addressFields, checkbox, customAddressFields, millis) {
  if (typeof(millis) === 'undefined') millis = 0;

  if(parseInt(value) > 0) {
    streamingFields.show(millis);
  } else {
    streamingFields.hide(millis);
  }
  if(parseInt(value) == 2) {
    addressFields.hide(millis);
    customAddressFields.hide(millis);
  } else if(millis > 0) {
    addressFields.show(millis);
    showOrHideCustomAddress(checkbox, customAddressFields, millis);
  }
}

var showOrHideCustomAddress = function(checkbox, fields, millis) {
  if (typeof(millis) === 'undefined') millis = 0;

  if($(checkbox).is(':checked')) {
    fields.show(millis);
  } else {
    fields.hide(millis);
  }
}

$(function() {
  var streamingRadios = $('#fieldset-praktische-info #formfield-form-widgets-streaming input[type="radio"]');
  // What to hide when no streaming
  var streamingFields = $('#fieldset-praktische-info #formfield-form-widgets-streamingurl');
  var addressCheckboxes = $('#fieldset-fieldset-locatie #form-widgets-nieuwe-locatie-0, ' +
    '#fieldset-praktische-info #form-widgets-nieuwe-locatie-0');
  // What to hide when only streaming
  var addressFields = $('#fieldset-fieldset-locatie, #fieldset-praktische-info').find(
    '#formfield-form-widgets-kies-locatie, #formfield-form-widgets-nieuwe-locatie'
  );
  // Fields for "nieuwe locatie"
  var customAddressFields = $('#fieldset-fieldset-locatie, #fieldset-praktische-info').find(
    '#formfield-form-widgets-locatie_naam,' +
    '#formfield-form-widgets-locatie_straat, #formfield-form-widgets-locatie_nr,' +
    '#formfield-form-widgets-locatie_postcode, #formfield-form-widgets-locatie_plaats'
  );

  showOrHideCustomAddress(addressCheckboxes, customAddressFields);
  addressCheckboxes.on('change', function() {
    showOrHideCustomAddress(this, customAddressFields, 400);
  });

  var initialRadioVal = parseInt($('#fieldset-praktische-info #formfield-form-widgets-streaming input[type="radio"]:checked').val());
  showOrHideAddress(initialRadioVal, streamingFields, addressFields, addressCheckboxes, customAddressFields);
  streamingRadios.on('change', function() {
    showOrHideAddress(this.value, streamingFields, addressFields, addressCheckboxes, customAddressFields, 400);
  });
});
